import { FieldMessageProps } from './field-message.types';
import { FieldVerdict } from '../_core/field';

const STATUS_PRIORITY: readonly FieldVerdict[] = [
  'error',
  'warning',
  'success',
];

type ResolvedMessage = {
  message: string;
  status?: FieldVerdict;
  /** Вердикта ещё нет: показываем ожидание, а не устаревший статус */
  isPending?: boolean;
};

export const resolveMessage = (
  props: FieldMessageProps
): ResolvedMessage | null => {
  const { status, hint } = props;

  if (status) {
    const message = props[status] || hint;

    if (!message) {
      return null;
    }

    return status === 'pending'
      ? { message, isPending: true }
      : { message, status };
  }

  if (props.pending) {
    return { message: props.pending, isPending: true };
  }

  const resolvedStatus = STATUS_PRIORITY.find((key) => props[key]);

  if (resolvedStatus) {
    return { message: props[resolvedStatus] as string, status: resolvedStatus };
  }

  return hint ? { message: hint } : null;
};
